import React from "react";

export const FilterModalSelect = ({
  label,
  onChange,
  value,
  options,
  placeholderText,
}) => (
  <>
    <div className="filters-modal__label">
      {label}
    </div>
    <select
      defaultValue=""
      onChange={e=>onChange(e.target.value)}
      value={value}
      className="filters-modal-select"
    >
      <option selected="true" disabled="disabled" value="">
        {placeholderText}
      </option>
      {options.map((option) => (
        <option value={option.value ?? option.name}>{option.name}</option>
      ))}
    </select>
  </>
);
